import { alwaysTrue, expected, toKind } from "../verify.js";

export function isOneOf<In, Out extends In>(
  ...verifiers: ((value: In) => value is Out)[]
): (value: In) => value is Out {
  if (import.meta.env.DEV) {
    function verify(input: In): input is Out {
      for (const verifier of verifiers) {
        if (verifier(input)) {
          return true;
        }
      }

      return false;
    }

    const expectation = expected.updated(verify, {
      to: (to) => {
        if (to === undefined) {
          return ["to be one of", "any"];
        } else {
          return `${toKind(to)} or any`;
        }
      },
      actual: (actual) => {
        return (input: In) => {
          if (actual) {
            return actual(input);
          }
        };
      },
    });

    return expected.associate(verify, expectation);
  }
  return alwaysTrue;
}
